import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Following would be replaced by simple export from "./components",
// once we deprecate ..../courses/:courseId/circulars route
// or we update that route to use V2 FeatureFlag for Announcements/Circulars
export default store => ({
  path: ":circular_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-communications" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
